var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDaPassedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#4CAF50",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 400 400"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.996 0C89.713 0 0 89.72 0 200s89.713 200 199.996 200S400 310.28 400 200 310.279 0 199.996 0zm0 373.77C104.18 373.77 26.23 295.816 26.23 200c0-95.817 77.949-173.769 173.766-173.769S373.767 104.184 373.767 200c.001 95.816-77.955 173.77-173.771 173.77z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M272.406 134.526L169.275 237.652l-41.689-41.68c-5.123-5.117-13.422-5.12-18.545.003-5.125 5.125-5.125 13.425 0 18.548l50.963 50.955c2.561 2.558 5.916 3.838 9.271 3.838s6.719-1.28 9.279-3.842c.008-.011.014-.022.027-.035L290.95 153.071c5.125-5.12 5.125-13.426 0-18.546-5.122-5.123-13.427-5.123-18.544.001z"
  })));
}

export default SvgDaPassedIcon;